import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                <g id="icon-close">
                    <path fill="currentColor" d="M.636 12.374L12.445.565l.99.99-11.81 11.809z"></path>
                    <path fill="currentColor" d="M.636 1.626l.99-.99 11.809 11.809-.99.99z"></path>
                </g>
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-active-filters-controls ns-d-flex ns-flex-wrap ns-align-items-center ns-pt-0 ns-pb-20">
                <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-selected-filter"
                        >
                            <span class="ns-color-black">
                                {filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                    <button
                        type="button"
                        class="ns-anchor ns-clear-filters-link ns-text-align-right ns-mr-0"
                        onClick={() => {
                            removeAll()
                        }}
                    >
                        Clear all
                    </button>
                </div>
            </div>
        )
    )
}
